import { css } from '@emotion/react';
import { type ThemeProps } from '~/_shared/types/themeProps';

export const trialMessageStyle = ({ theme }: ThemeProps) => css({
  color: theme.textColors.warning,
  display: 'flex',
  gap: 4,
});
